
import { Base } from '../base-component';

import './want-to-menu.component.scss';

export class WantToMenu extends Base {

	constructor(element: Element){
		super(element);
	}

	init() {}

	bindEvents() {}

}



// WEBPACK FOOTER //
// ./components/want-to-menu/want-to-menu.component.ts